import { Fragment, ReactElement } from 'react';

import { MarriageDetailAnscNotificationsNonResidentCancellationsCrumbs } from 'cancellations/constants/ansc-notifications.crumbs';
import PersonMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/ansc-notifications/research-marriage-non-resident/edit-person';
import { IdAmbito } from 'shell/constants/id-ambito';

const PersonMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonMarriageNonResidentNotificationsCivilStatusShared
        scope={IdAmbito.Cancellazioni}
        items={MarriageDetailAnscNotificationsNonResidentCancellationsCrumbs()}
      />
    </Fragment>
  );
};

PersonMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonMarriageNonResidentNotificationsCivilStatusPage;
